"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompensationDisclaimerTitle = exports.CompensationDisclaimer = exports.CompensationCountryFlag = exports.CompensationInput = exports.CompensationInputExtra = exports.CompensationInputStyle = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Input = require("../Form/Input");

var _style = require("../Form/style");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CompensationInputStyle = (0, _styledComponents.css)(["--spacingX:16px;--spacingY:6px;padding:var(--spacingY) var(--spacingX);border:var(--inputBorderSize) solid transparent;border-color:var(--inputBorderColor);"]);
exports.CompensationInputStyle = CompensationInputStyle;

var CompensationInputExtra = _styledComponents["default"].div.withConfig({
  displayName: "Compensation__CompensationInputExtra",
  componentId: "sc-1br24ku-0"
})(["", " ", " width:auto;"], _style.InputStyle, CompensationInputStyle);

exports.CompensationInputExtra = CompensationInputExtra;

var CompensationInput = _styledComponents["default"].div.withConfig({
  displayName: "Compensation__CompensationInput",
  componentId: "sc-1br24ku-1"
})(["display:flex;", "{", " background:var(--inputBackground);flex-grow:1;}", "{border-right-width:0;}", " + ", "{border-left-width:0;border-right-width:var(--inputBorderSize);}"], _Input.Input, CompensationInputStyle, CompensationInputExtra, _Input.Input, CompensationInputExtra);

exports.CompensationInput = CompensationInput;

var CompensationCountryFlag = _styledComponents["default"].img.withConfig({
  displayName: "Compensation__CompensationCountryFlag",
  componentId: "sc-1br24ku-2"
})(["width:25px;margin-right:10px;"]);

exports.CompensationCountryFlag = CompensationCountryFlag;

var CompensationDisclaimer = _styledComponents["default"].div.withConfig({
  displayName: "Compensation__CompensationDisclaimer",
  componentId: "sc-1br24ku-3"
})(["", " ", ";color:var(--colorDefault);margin-top:24px;padding-left:12px;padding-right:12px;mark,strong{color:var(--colorHighlight);font-weight:500;}"], function (_ref) {
  var theme = _ref.theme;

  switch (theme.mode) {
    case 'dark':
      return (0, _styledComponents.css)(["--colorDefault:var(--colors-bayoux);--colorHighlight:var(--colors-darkBlue);"]);

    case 'light':
    default:
      return (0, _styledComponents.css)(["--colorDefault:var(--colors-heather);--colorHighlight:var(--colors-blank);"]);
  }
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.bodySM;
});

exports.CompensationDisclaimer = CompensationDisclaimer;

var CompensationDisclaimerTitle = _styledComponents["default"].span.withConfig({
  displayName: "Compensation__CompensationDisclaimerTitle",
  componentId: "sc-1br24ku-4"
})(["", ";color:var(--colorHighlight);"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.bodyMedium;
});

exports.CompensationDisclaimerTitle = CompensationDisclaimerTitle;